import Glide, {
    Controls,
    Breakpoints,
    Swipe,
} from '@glidejs/glide/dist/glide.modular.esm';

export default class Slider {
    constructor() {
        // version with a peak on the right
        const glides = document.querySelectorAll(
            '[data-behaviour="glide-extended"]',
        );
        if (glides.length > 0) {
            glides.forEach((glide) => {
                new Glide(glide, {
                    type: 'slider',
                    startAt: 0,
                    perView: 4,
                    bound: 4,
                    gap: 20,
                    peek: { before: 0, after: 120 },
                    rewind: false,
                    breakpoints: {
                        768: {
                            perView: 1,
                            peek: { before: 20, after: 90 },
                        },
                        1024: {
                            perView: 2,
                            peek: { before: 48, after: 120 },
                        },
                        1365: {
                            perView: 3,
                            peek: { before: 48, after: 120 },
                        },
                    },
                }).mount({ Swipe, Controls, Breakpoints });
            });
        }

        // full screen with a peep either side
        const largeGlides = document.querySelectorAll(
            '[data-behaviour="glide-fullscreen"]',
        );
        if (largeGlides.length > 0) {
            largeGlides.forEach((glide) => {
                new Glide(glide, {
                    type: 'carousel',
                    startAt: 1,
                    perView: 5,
                    gap: 20,
                    peek: { before: 120, after: 120 },
                    breakpoints: {
                        768: {
                            perView: 2,
                            peek: { before: 40, after: 40 },
                        },
                        1024: {
                            perView: 3,
                            peek: { before: 60, after: 60 },
                        }
                        
                    },
                }).mount({ Swipe, Controls, Breakpoints });
            });
        }

        const mobileGlides = document.querySelectorAll(
            '[data-behaviour="glide"]',
        );

        if (mobileGlides.length > 0) {
            mobileGlides.forEach((glide) => {
                new Glide(glide, {
                    type: 'slider',
                    startAt: 0,
                    perView: 3,
                    bound: 3,
                    gap: 20,
                    rewind: false,
                    breakpoints: {
                        768: {
                            perView: 1,
                            peek: { before: 20, after: 70 },
                        },
                        1024: {
                            perView: 2,
                            peek: { before: 48, after: 120 },
                        },
                    },
                }).mount({ Swipe, Controls, Breakpoints });
            });
        }
    }
}
